import {
    ComponentType,
    useMemo,
} from 'react'
import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import BulkUploadButton from 'app/shared-components/BulkUploadButton'
import {
    TableFilterParams,
} from 'app/types/common.types'

import CreateButton from '../CreateButton'

type ActionComponentProps = {
    getFilterParams?: () => TableFilterParams
    isMenuItem?: boolean
}

type ActionsMap = Record<ActionComponentsKey, ComponentType<ActionComponentProps> | null>

const actionsMap: ActionsMap = {
    Create: CreateButton,
    Print: null,
    BulkCreate: null,
    BulkEdit: null,
    BulkUpload: BulkUploadButton,
}

type Props = {
    toolbarActions: ActionComponentsKey[]
    toolbarActionsProps: ActionComponentProps
}

const useAllowedToolbarActions = ({
    toolbarActions,
    toolbarActionsProps,
}: Readonly<Props>) => {
    return useMemo(() => {
        const allowedActions = Object.keys(actionsMap).reduce((acc, key) => {
            if (toolbarActions?.includes(key as ActionComponentsKey)) {
                acc[key] = actionsMap[key]
            }
            return acc
        }, {}) as ActionsMap

        return Object.values(allowedActions).map((Action) => {
            return (
                <Action
                    getFilterParams={toolbarActionsProps.getFilterParams}
                    isMenuItem={toolbarActionsProps.isMenuItem}
                />
            )
        })
    }, [
        toolbarActions,
        toolbarActionsProps,
    ])
}

export default useAllowedToolbarActions
